function urlSafeBase64(fileUrl) {
  const base64 = window.btoa(fileUrl)
  return base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
}

function isURIType(input) {
  return input.startsWith('data:')
}

export function getFileName(url) {
  const parts = url.split('/')
  const lastPart = parts[parts.length - 1]
  if (lastPart.includes('?')) return lastPart.split('?')[0]
  return lastPart
}

export function getImgProxySrc(src) {
  if (isURIType(src)) return src
  const encodedUrl = urlSafeBase64(src)
  const baseURL = process.env.VUE_APP_IMGPROXY_URL
  return `${baseURL}/_/${encodedUrl}`
}

export async function downloadImgByProxy(src, fileName) {
  if (!src || isURIType(src)) return
  const response = await fetch(getImgProxySrc(src))
  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
